import { Card, CardContent } from "@/components/ui/card";
import ArOfficeStaffPayslipForm from "@/v2/components/pages/payslip/ar-office-staff/Form";
import FormPageHeading from "@/v2/components/ui/heading/FormPage";
import { ReceiptTextIcon } from "lucide-react";
import { useParams } from "react-router-dom";

export default function EditArOfficeStaffPayslipPage() {
  const { id } = useParams();

  return (
    <div className="my-3 min-h-screen">
      <Card className="rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
        <FormPageHeading
          title="Payslip Management"
          description="Update Ar office staff payslips"
          Icon={ReceiptTextIcon}
        />
        <CardContent className="pt-6">
          <ArOfficeStaffPayslipForm id={id} />
        </CardContent>
      </Card>
    </div>
  );
}
